import proj4 from "proj4";
import { register } from "ol/proj/proj4";
import Projection from "ol/proj/Projection";
import olTileGrid from "ol/tilegrid/TileGrid";

proj4.defs(
  "EPSG:27700",
  "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs"
);
register(proj4);

const resolutions = [
  896, 448, 224, 112, 56, 28, 14, 7, 3.5, 1.75, 0.875, 0.4375, 0.21875,
  0.109375,
];
const extent = [-238375, 0, 900000, 1376256];

const Epsg27700 = new Projection({
  code: "EPSG:27700",
  extent: extent,
  units: "m",
});

const Epsg27700TileGrid = new olTileGrid({
  extent: extent,
  tileSize: 512,
  resolutions: resolutions,
});

export { Epsg27700, Epsg27700TileGrid };
export default Epsg27700;
